import { Menu } from 'lucide-react';
import { getSeptimaLogoPath } from '@/lib/logos';
import Image from '@/lib/Image';

interface MobileTopBarProps {
    onOpen: () => void;
    frontendLabel: string;
}

// Shown below lg only. Provides hamburger access to the sidebar that
// disappears with hidden lg:flex.
export default function MobileTopBar({ onOpen, frontendLabel }: MobileTopBarProps) {
    return (
        <header className="lg:hidden flex items-center gap-3 h-14 px-3 border-b border-[rgb(var(--color-divider))] bg-[rgb(var(--color-surface))] flex-shrink-0">
            <button
                type="button"
                onClick={onOpen}
                aria-label="Open navigation menu"
                className="w-10 h-10 flex items-center justify-center rounded-button hover:bg-[rgb(var(--color-surface-secondary))] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgb(var(--color-accent))]"
            >
                <Menu className="w-5 h-5 text-[rgb(var(--color-text-primary))]" />
            </button>
            <div className="flex items-center gap-2 min-w-0">
                <Image
                    src={getSeptimaLogoPath()}
                    alt="Septima"
                    width={24}
                    height={24}
                    className="dark:invert flex-shrink-0"
                />
                <span className="text-body-medium font-medium truncate">{frontendLabel}</span>
            </div>
        </header>
    );
}
